const AboutUsMobileMiddleVector = ({
  width = 288,
  height = 451,
  fill = "#F8EDE3",
  className = ""
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 288 451"
      fill="none"
      className={className}
    >
      <path
        d="M18.6777 450.019L285.66 276.644C287.872 275.208 288.494 272.253 287.062 270.049L113.687 3.06608C112.227 0.817274 109.166 0.179466 106.944 1.66476C-40.3035 100.377 -82.4131 298.473 11.9502 448.544C13.3759 450.805 16.4315 451.467 18.6729 450.012L18.6777 450.019Z"
        fill={fill}
      />
    </svg>
  );
};

export default AboutUsMobileMiddleVector;
